import React from 'react';
import { IonCard, IonCardContent, IonList } from '@ionic/react';
import './SectionCard.css';

type IonListProps = React.ComponentProps<typeof IonList>;
type DataAttributes = {
  [key: `data-${string}`]: string | number | boolean | undefined;
};
type SectionCardListProps = IonListProps & DataAttributes;

interface SectionCardProps {
  children: React.ReactNode;
  className?: string;
  /**
   * Custom section label, rendered above the card (outside the rounded
   * rectangle). Reach for `title` instead when a plain string in the standard
   * style is all you need; `header` wins when both are supplied.
   */
  header?: React.ReactNode;
  /** Plain-text section label rendered above the card in the standard style. */
  title?: string;
  noBottomMargin?: boolean;
  listProps?: SectionCardListProps;
}

const SectionCard: React.FC<SectionCardProps> = ({
  children,
  className = '',
  header,
  title,
  noBottomMargin = false,
  listProps,
}) => {
  const classes = [
    'section-card',
    noBottomMargin && 'section-card--flush',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const label =
    header ??
    (title ? <div className="section-card__title">{title}</div> : null);

  // A fragment rather than a wrapping element: the label lands directly in the
  // caller's block flow above the card, and a card with no label keeps exactly
  // the DOM it had before the label existed.
  return (
    <>
      {label}
      <IonCard className={classes}>
        <IonCardContent className="section-card__content">
          <IonList className="section-card__list" {...listProps}>
            {children}
          </IonList>
        </IonCardContent>
      </IonCard>
    </>
  );
};

export default SectionCard;
